import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import ReactDOMServer from 'react-dom/server';
import { Tabs, Tree, Card, Row, Col, message, Button, Modal, Input } from 'antd'
import { PlusOutlined, DeleteOutlined, EditOutlined, ExportOutlined } from '@ant-design/icons'
import { ReactComponent as DownIcon } from '@/assets/svg/down-out-zd.svg'
import { Column, Editors, GridOption, OnCellChangeEventArgs, OnClickEventArgs, SlickgridReactInstance } from 'slickgrid-react'
import SlickGridComponent, { SlickGridRef } from '@/components/SlickGrid'
import CustomTextEditor from '@/components/SlickGrid/CustomTextEditor'
import { useSetState, useSize } from 'ahooks'
import { getViewByProjectId, getViewsFolderByViewId } from '@/pages/documentCompile/api/data-project-view'
import { getCatalogList, addCatalog, updateCatalog, deleteCatalog } from '@/pages/documentCompile/api/data-project-catalog'
import useScreenHeight from '@/hooks/useScreenHeight'
import { ISO216_OPTIONS } from '@/pages/documentCompile/dict/constant'
import { arrayToTree } from '@/utils/tree'
import styles from './index.module.less'
import { uniq } from '@/utils/tools';
import useMethods from '../../onlyofficeFieldSetting/hooks/usemethods';
import ExportConfirmModal from '../detail/components/ExportConfirmModal';

export default function DirPage() {
    const [searchParams] = useSearchParams()
    const projectId = searchParams.get('projectId')
    const editable = searchParams.get('editable')
    const isEditable = editable === '1'
    const gridRef = useRef<SlickGridRef>(null)
    const getReactGridInstance = () => gridRef.current?.getReactGridInstance()
    const { height: bodyHeight } = useSize(document.body)
    // const treeHeight = useMemo(() => {
    //     return screenHeight - 300
    // }, [screenHeight])

    const [state, setState] = useSetState({
        views: [] as any[],
        activeViewId: null as string | null,
        treeData: [] as any[],
        treeExpandKey: [] as any[],
        treeSelectKeys: [] as any[],
        documentList: [] as any[], // 存储所有文档节点
        catalogList: [] as any[],
        loading: false,
        selectedRowIndex: null as number | null,
        exportLoading: false,
        exportModalVisible: false,
    })

    const { handleExport } = useMethods();

    // 表格配置
    // const gridOptions: GridOption = useMemo(() => {
    //     return {
    //         gridWidth: '100%',
    //         autoEdit: true,
    //         editable: true,
    //         autoCommitEdit: true,
    //         enableAutoResize: true,
    //         autoResize: {
    //             container: '#catalog-grid-container',
    //             rightPadding: 10,
    //             bottomPadding: 10,
    //             calculateAvailableSizeBy: 'container'
    //         },
    //     }
    // }, [])

    const [gridOptions, setGridOptions] = useState<GridOption>({
        gridWidth: '100%',
        autoEdit: true,
        editable: true,
        autoCommitEdit: true,
        enableAutoResize: true,
        autoResize: {
            container: '#catalog-grid-container',
            rightPadding: 10,
            bottomPadding: 10,
            calculateAvailableSizeBy: 'container'
        },
    })

    // 所有被关联的文档数据
    const allRelDocIds = useMemo(() => {
        if (!state.catalogList) return [];
        // 遍历 catalogList，提取所有 relDocIds 并合并成一个数组
        const result: number[] = [];
        for (const catalog of state.catalogList) {
            if (Array.isArray(catalog.relDocIds)) {
                result.push(...catalog.relDocIds);
            }
        }
        return uniq(result) as any[];
    }, [state.catalogList]);


    // 缓存文档选项数据
    // const documentOptions = useMemo(() => {
    //     let docListTemp = []
    //     if (state.documentList && state.documentList.length > 0) {
    //         // 下拉列表的关联文档数据只能被引用一次
    //         // 从 state.documentList 中过滤掉 rid =  state.catalogList 中 relDocIds 的记录
    //         docListTemp = state.documentList.filter(doc => !allRelDocIds.includes(doc.id))
    //     } else {
    //         docListTemp = state.documentList
    //     }

    //     return docListTemp
    //         .sort((a, b) => (a.sortNo || 0) - (b.sortNo || 0)) // 按排序号排序
    //         .map(doc => ({
    //             label: doc.title || doc.name,
    //             value: doc.id,
    //             // value: doc.rid,
    //         }))
    // }, [state.documentList, allRelDocIds])
    const [documentOptions, setDocumentOptions] = useState<any[]>([])

    useEffect(() => {
        let options = state.documentList
            .sort((a, b) => (a.sortNo || 0) - (b.sortNo || 0)) // 按排序号排序
            .map(doc => ({
                label: doc.title || doc.name,
                value: doc.id,
            }))
        setDocumentOptions(options)
    }, [state.documentList])


    console.log("documentOptions", documentOptions)


    // 缓存文档映射，方便快速查找
    const documentMap = useMemo(() => {
        const map = new Map()
        state.documentList.forEach(doc => {
            map.set(doc.id, doc.title || doc.name)
            // map.set(doc.rid, doc.title || doc.name)
        })
        return map
    }, [state.documentList])

    // 表格列定义
    const columns: Column[] = [
        // {
        //     id: 'index',
        //     name: '序号',
        //     field: 'index',
        //     minWidth: 80,
        //     maxWidth: 80,
        //     cssClass: 'slickgrid-checkbox-center-cls',
        //     formatter: (_row, _cell, value, _columnDef, dataContext, grid) => {
        //         return `${_row + 1}`
        //     }
        // },
        {
            id: 'num',
            name: '序号',
            field: 'num',
            minWidth: 50,
            maxWidth: 50,
            cssClass: 'slickgrid_column_number slickgrid-checkbox-center-cls',
            behavior: "select",
            formatter: (_row, _cell, value, _columnDef, dataContext, grid) => { return `${_row + 1}` }
        },
        {
            id: 'catalogName',
            field: 'catalogName',
            name: '目录名称',
            minWidth: 200,
            cssClass: 'slickgrid-edit',
            editor: {
                model: CustomTextEditor,
                placeholder: '请输入目录名称',
                required: true
            }
        },
        {
            id: 'relDocIds',
            field: 'relDocIds',
            name: '关联文档',
            minWidth: 320,
            toolTip: 'relDocIds',
            cssClass: 'slickgrid_custom_select slickgrid-edit',
            editor: {
                collection: documentOptions,
                // 动态调整collection，编辑时包含当前行已选择的文档
                // collectionOverride: (originalCollection: any[], args: any) => {
                //     console.log("collectionOverride", originalCollection)
                //     const { dataContext } = args;
                //     const currentRelDocIds = dataContext?.relDocIds || [];

                //     // 如果当前行没有关联文档，直接返回原始集合
                //     if (!currentRelDocIds || currentRelDocIds.length === 0) {
                //         return originalCollection;
                //     }

                //     // 获取当前行已选择的文档信息
                //     const currentSelectedDocs = currentRelDocIds.map((docId: number) => ({
                //         label: documentMap.get(docId) || `ID: ${docId}`,
                //         value: docId,
                //     }));

                //     // 合并原始选项和当前已选择的文档
                //     const mergedCollection = [...originalCollection];

                //     // 添加当前行已选择但不在原始集合中的文档
                //     currentSelectedDocs.forEach((selectedDoc: any) => {
                //         const exists = mergedCollection.some(doc => doc.value === selectedDoc.value);
                //         if (!exists) {
                //             mergedCollection.push(selectedDoc);
                //         }
                //     });

                //     return mergedCollection;
                // },
                customStructure: {
                    label: 'label',
                    value: 'value',
                },
                editorOptions: {
                    classes: 'slickgrid_custom_editor_multiple_select',
                },
                model: Editors.multipleSelect,
            },
            formatter: (_row, _cell, value, _columnDef, dataContext, grid) => {
                if (!value || !Array.isArray(value) || value.length === 0) {
                    return '请选择文档'
                }
                // 根据ID查找文档名称
                const docNames = value.map(docId => {
                    return documentMap.get(docId) || `ID: ${docId}`
                })
                return `${docNames.join(', ')} (${value.length}个)`
            }
        },
        {
            id: 'source',
            field: 'source',
            name: '原图纸编码或文件',
            minWidth: 150,
            cssClass: 'slickgrid-edit',
            editor: {
                model: CustomTextEditor,
                placeholder: '请输入原图纸编码或文件'
            }
        },
        {
            id: 'pageCount',
            field: 'pageCount',
            name: '页数',
            minWidth: 100,
            cssClass: 'slickgrid-edit',
            editor: {
                model: CustomTextEditor,
                placeholder: '0'
            },
            formatter: (_row, _cell, value, _columnDef, dataContext, grid) => {
                return value || '0'
            }
        },
        {
            id: 'iso216',
            field: 'iso216',
            name: '图幅',
            minWidth: 120,
            cssClass: 'slickgrid_custom_select slickgrid-edit',
            editor: {
                collection: ISO216_OPTIONS,
                customStructure: {
                    label: 'label',
                    value: 'value',
                },
                editorOptions: {
                    classes: 'slickgrid_custom_editor_single_select'
                },
                model: Editors.singleSelect,
            },
            formatter: (_row, _cell, value, _columnDef, dataContext, grid) => {
                return value || 'A4'
            }
        },
        {
            id: 'pageStart',
            field: 'pageStart',
            name: '开始页码',
            minWidth: 100,
            cssClass: 'slickgrid-edit-disabled',
            formatter: (_row, _cell, value, _columnDef, dataContext, grid) => {
                return value > 0 ? String(value).padStart(3, '0') : '--'
            }
        },
        {
            id: 'pageEnd',
            field: 'pageEnd',
            name: '结束页码',
            minWidth: 100,
            cssClass: 'slickgrid-edit-disabled',
            formatter: (_row, _cell, value, _columnDef, dataContext, grid) => {
                return value > 0 ? String(value).padStart(3, '0') : '--'
            }
        },
        {
            id: 'remark',
            field: 'remark',
            name: '备注',
            minWidth: 150,
            cssClass: 'slickgrid-edit',
            editor: {
                model: CustomTextEditor,
                placeholder: '请输入备注'
            }
        },
        {
            id: 'action',
            field: 'action',
            name: '操作',
            minWidth: 120,
            // cssClass: 'slickgrid-edit-disabled slickgrid-checkbox-center-cls',
            cssClass: 'slickgrid-edit slickgrid-checkbox-center-cls',
            formatter: (_row, _cell, value, _columnDef, dataContext, grid) => {
                // return `<a href='javascript:void(0)' class='op-add'>新增</a><span style='margin: 0 8px;'></span><a href='javascript:void(0)' class='op-delete'>删除</a>`
                return `<a href='javascript:void(0)' class='custom-slickgrid-op op-add'>新增</a>
                <span style='margin: 0 8px;'>
                </span><a href='javascript:void(0)' class='custom-slickgrid-op op-delete'>删除</a>`
            }
        }
    ]

    function relDocIdsTooltipFormatter(row, cell, value, columnDef, dataContext) {
        // 根据ID查找文档名称
        const docNames = value.map(docId => {
            return documentMap.get(docId) || `ID: ${docId}`
        })
        const text = `${docNames.join(', ')} (${value.length}个)`
        let $el = $(`<div class='zdCls'></div>`)
            .html(`<span class='zdTextCls'>${text}</span><div class='zdIconCls'>${ReactDOMServer.renderToStaticMarkup(<DownIcon />)}</div>`)
            .attr("title", text)
        return $el[0].outerHTML;
    }

    columns.forEach((column) => {
        if (column.toolTip === 'relDocIds') {
            column.formatter = relDocIdsTooltipFormatter;
        }
    });


    // 获取所有文档节点（叶子节点）
    const getAllDocuments = (treeData: any[]): any[] => {
        const documents: any[] = []

        const traverse = (nodes: any[]) => {
            nodes.forEach(node => {
                if (node.isLeaf) {
                    documents.push(node)
                } else if (node.children && node.children.length > 0) {
                    traverse(node.children)
                }
            })
        }

        traverse(treeData)
        return documents
    }

    // 获取树结构数据
    const loadTreeData = async () => {
        if (!projectId || !state.activeViewId) return
        try {
            const viewData = await getViewsFolderByViewId(projectId, state.activeViewId)
            const filteredViewdata = viewData.filter(vItem => !vItem.folder)
            // const filteredViewdata = viewData
            // filteredViewdata.forEach(item => {
            //     item.rid = item.id
            //     if (!item.folder) {
            //         item.id = `${item.id}${item.parentId}`
            //     }
            // })
            // 使用 arrayToTree 将扁平数组转换为树结构
            const { tree: treeData, expandKey } = arrayToTree(filteredViewdata, {
                idField: "id",
                pidField: "parentId",
                keyField: "id",
                titleField: "name",
            })

            // 提取所有文档节点并存储
            const documentList = getAllDocuments(treeData)

            setState({ treeData, documentList, treeExpandKey: expandKey })
        } catch (error) {
            message.error('获取树结构数据失败')
        }
    }

    // 计算起止页码
    const calculatePageRange = (catalogList: any[]) => {
        let currentPage = 1

        return catalogList.map((item, index) => {
            const pageCount = item.pageCount || 0
            const pageStart = pageCount > 0 ? currentPage : 0
            const pageEnd = pageCount > 0 ? currentPage + pageCount - 1 : 0

            // 为下一个目录更新起始页码
            if (pageCount > 0) {
                currentPage = pageEnd + 1
            }

            return {
                ...item,
                pageStart,
                pageEnd
            }
        })
    }

    // 志强大佬确认，如果目录列表为空时，默认新增一条数据
    const addDefaultCatalog = async () => {
        try {
            const newCatalog = {
                catalogName: '新增目录',
                pageCount: 0,
                projectId,
                viewId: state.activeViewId,
                // iso216: 'A4'
            }
            await addCatalog([newCatalog])
            loadCatalogList()
        } catch (error) {
            console.error('新增失败', error)
        }
    }


    // 获取目录列表
    const loadCatalogList = async () => {
        if (!projectId || !state.activeViewId) return
        try {
            setState({ loading: true })
            const catalogList = await getCatalogList({
                projectId,
                viewId: state.activeViewId
            })

            // 计算起止页码
            const dataWithPageRange = calculatePageRange(catalogList)

            const newData = dataWithPageRange.map((item, index) => ({
                ...item,
                id: item.catalogId
            }))
            setState({ catalogList: newData, loading: false })
            // 志强大佬确认，没有数据时新增一条
            if (newData?.length === 0) {
                await addDefaultCatalog()
            } else {
                setState({ catalogList: newData, loading: false })
            }
        } catch (error) {
            message.error('获取目录列表失败')
            setState({ loading: false })
        }
    }


    // 获取视图列表
    const loadViews = async () => {
        if (!projectId) return
        try {
            const views = await getViewByProjectId(projectId)
            setState({ views })
            if (views && views.length > 0) {
                const viewId = views[0].id
                setState({ activeViewId: viewId })
            }
        } catch (error) {
            message.error('获取视图列表失败')
        }
    }


    // 视图切换
    const handleViewChange = (viewId: string) => {
        setState({ activeViewId: viewId })
    }

    // 计算关联文档的页数
    const calculatePageCount = (relDocIds: number[]) => {
        if (!relDocIds || relDocIds.length === 0) return 0

        // 根据关联的文档数量计算页数（每个文档按1页计算）
        return relDocIds.length
    }

    // 检查文档是否已被其他目录关联
    const checkDocumentConflict = useCallback((newRelDocIds: number[], currentCatalogId: number) => {
        const conflictDocs = []

        for (const docId of newRelDocIds) {
            const existingCatalog = state.catalogList.find(catalog =>
                catalog.catalogId !== currentCatalogId &&
                catalog.relDocIds &&
                catalog.relDocIds.includes(docId)
            )

            if (existingCatalog) {
                const docName = documentMap.get(docId) || `文档ID: ${docId}`

                conflictDocs.push({
                    docName,
                    catalogName: existingCatalog.catalogName
                })
            }
        }

        return conflictDocs
    }, [state.catalogList, documentMap])

    // 单元格变化处理
    const handleCellChange = async (e: CustomEvent<{ eventData: any; args: OnCellChangeEventArgs; }>) => {
        const { args } = e.detail
        const { item, column } = args

        try {
            // 如果是关联文档变化，检查是否有冲突
            if (column.id === 'relDocIds') {
                const conflictDocs = checkDocumentConflict(item[column.id], item.catalogId)
                if (conflictDocs.length > 0) {
                    const conflictMessages = conflictDocs.map(doc =>
                        `文档"${doc.docName}"已被目录"${doc.catalogName}"关联`
                    ).join('；')

                    message.error(`关联失败：${conflictMessages}`)
                    loadCatalogList() // 重新加载数据以恢复原状态
                    return
                }
            }

            let updateData = {
                catalogId: item.catalogId,
                [column.id]: item[column.id]
                // [column.id]: column.id === 'relDocIds' ? [item[column.id]] : item[column.id]
            }

            // 如果是关联文档变化，自动计算页数
            if (column.id === 'relDocIds') {
                // const pageCount = calculatePageCount(item[column.id])
                // updateData = {
                //     ...updateData,
                //     // pageCount
                // }
            }

            await updateCatalog([updateData])
            message.success('更新成功')

            // 如果是页数变化或关联文档变化，重新加载列表以更新起止页码
            if (column.id === 'pageCount' || column.id === 'relDocIds') {
                loadCatalogList()
            }
        } catch (error) {
            message.error('更新失败')
        }
    }


    // 新增目录
    const handleAddCatalog = async (rowData: any, insertIndex: number) => {
        try {
            const newCatalog = {
                catalogName: '新增目录',
                pageCount: 0,
                projectId,
                viewId: rowData.viewId,
                baseId: rowData.catalogId, // 定位新插入记录的基准记录的id，若不指定或指定记录不存在，则插入到最末尾
                baseOffset: insertIndex + 1,// 插入位置偏移量，大于0表示插入在基准记录之后，小于0表示插入在基准记录之前
                // iso216: 'A4'
            }

            await addCatalog([newCatalog])
            message.success('新增成功')
            loadCatalogList()
        } catch (error) {
            message.error('新增失败')
        }
    }
    // 删除目录
    const handleDeleteCatalog = (rowData: any) => {
        if (!rowData) return
        // 志强大佬确认：仅剩一条时不能删除
        if (state.catalogList.length === 1) {
            message.warning('无法删除，请至少保留一条数据。')
            return
        }

        Modal.confirm({
            title: '确定删除该目录吗？',
            content: '删除后将自动更新其他行的数据',
            okText: '确认',
            cancelText: '取消',
            onOk: async () => {
                try {
                    await deleteCatalog([rowData.catalogId])
                    message.success('删除成功')
                    loadCatalogList()
                } catch (error) {
                    message.error('删除失败')
                }
            }
        })
    }

    // 表格点击处理
    const handleTableClick = (e: CustomEvent<{ eventData: any; args: OnClickEventArgs; }>) => {
        const { args, eventData } = e.detail
        const targetEle = eventData?.target
        const rowData = getReactGridInstance()?.gridService.getDataItemByRowIndex(args?.row)

        setState({ selectedRowIndex: args?.row })

        if (targetEle?.classList.contains('op-add')) {
            handleAddCatalog(rowData, args?.row)
        } else if (targetEle?.classList.contains('op-delete')) {
            handleDeleteCatalog(rowData)
        }
    }

    const handleTreeExpand = (expandedKeys: any[]) => {
        setState({ treeExpandKey: expandedKeys })
    }

    // 显示导出确认弹框
    const handleExportCatalog = () => {
        if (!state.activeViewId) {
            message.warning('请先选择视图');
            return;
        }
        setState({ exportModalVisible: true });
    };

    // 确认导出
    const handleExportConfirm = async (convertToPdf: boolean) => {
        const params = {
            convertToPdf,
            projectId: projectId,
            viewId: state.activeViewId
        };

        try {
            setState({ exportLoading: true });
            await handleExport(params);
            setState({ exportModalVisible: false });
        } catch (error) {
            console.error('导出失败:', error);
        } finally {
            setState({ exportLoading: false });
        }
    };

    // 取消导出
    const handleExportCancel = () => {
        setState({ exportModalVisible: false });
    };

    // 表格高度计算
    // console.log("screenHeight", bodyHeight);
    const tableHeight = useMemo(() => {
        return bodyHeight ? bodyHeight - 230 : 500
    }, [bodyHeight])
    const treeHeight = useMemo(() => {
        return bodyHeight ? bodyHeight - 300 : 500
    }, [bodyHeight])
    // 初始化数据
    useEffect(() => {
        if (projectId) {
            loadViews()
        }
    }, [projectId])

    useEffect(() => {
        if (state.activeViewId) {
            loadTreeData()
            loadCatalogList()
        }
    }, [state.activeViewId])

    useEffect(() => {
        if (state.documentList && state.documentList.length > 0) {
            loadCatalogList()
        }
    }, [state.documentList])

    useEffect(() => {
        gridRef.current?.getReactGridInstance()?.slickGrid.setOptions({
            editable: isEditable,
        })
        setGridOptions({
            ...gridOptions,
            editable: isEditable
        })
    }, [isEditable])

    if (!projectId) {
        return <div>缺少项目ID参数</div>
    }

    // console.log("state.catalogList", state.catalogList);
    console.log("allRelDocIds", allRelDocIds, state.treeData)

    return (
        <div className={styles.container} style={{ padding: '16px' }}>
            {/* 视图选择 */}
            <Tabs
                activeKey={state.activeViewId}
                onChange={handleViewChange}
                items={state.views.map(view => ({
                    key: view.id,
                    label: view.name,
                }))}
            />

            {/* 主要内容区域 */}
            <Row gutter={16}>
                {/* 左侧树结构 */}
                <Col span={8}>
                    <Card size='small' className={styles.card} title="资料目录" style={{ height: `${tableHeight}px` }}>
                        {
                            state.treeExpandKey.length > 0 && (
                                <Tree
                                    treeData={state.treeData}
                                    multiple
                                    showLine
                                    showIcon={false}
                                    height={treeHeight}
                                    defaultExpandAll
                                    selectedKeys={allRelDocIds}
                                    onExpand={handleTreeExpand}
                                    expandedKeys={state.treeExpandKey}
                                />
                            )
                        }
                    </Card>
                </Col>

                {/* 右侧表格 */}
                {/* <Col span={16}> */}
                <Col span={16}>
                    <Card
                        size='small'
                        className={styles.card}
                        title="卷内目录设置"
                        style={{ height: `${tableHeight}px` }}
                        extra={
                            <Button
                                type="link"
                                icon={<ExportOutlined />}
                                size="small"
                                loading={state.exportLoading}
                                onClick={handleExportCatalog}
                            >
                                导出
                            </Button>
                        }
                    >
                        <div id="catalog-grid-container" style={{ height: `${tableHeight - 40}px` }}>
                            <SlickGridComponent
                                ref={gridRef}
                                gridId="catalog-grid"
                                gridOptions={gridOptions}
                                columnDefinitions={columns}
                                dataset={state.catalogList}
                                loading={state.loading}
                                onCellChange={handleCellChange}
                                onClick={handleTableClick}
                            />
                        </div>
                    </Card>
                </Col>
            </Row>

            {/* 导出确认弹窗 */}
            <ExportConfirmModal
                visible={state.exportModalVisible}
                onCancel={handleExportCancel}
                onConfirm={handleExportConfirm}
                loading={state.exportLoading}
            />
        </div>
    )
}
